import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductTypeLabel, getFundsCategoryPath, getFundsListPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Tag } from '../../../../Tags';
import { Inner, CategoryTitle } from './partials';
export var CategoryCard = function CategoryCard(_ref) {
  var category = _ref.category,
    productType = _ref.productType;
  var theme = useTheme();
  return React.createElement(Inner, null, React.createElement(CategoryTitle, {
    as: AppLink,
    href: getFundsCategoryPath(theme, productType, category)
  }, category.name), React.createElement("div", null, React.createElement(AppLink, {
    href: getFundsListPath(theme, productType, {
      category: category.id
    })
  }, React.createElement(Tag, null, category.stats.funds, " ", getProductTypeLabel(productType, 'shortPlural', 'lowercase')))));
};